import React from 'react';
import { object } from 'prop-types';
import { faComments } from '@fortawesome/free-solid-svg-icons';

import Typography from 'ravenjs/lib/Typography';
import FaIcon from 'ravenjs/lib/FaIcon';

function CommentField(props) {
    const { row, col, handlers } = props;

    return (
        <Typography wordWrap type="span" fontFamily="Roboto" fontSize="0.875rem">
            <FaIcon
                color="grey"
                height="15px"
                icon={faComments}
                style={{ cursor: 'pointer', display: 'inline', paddingRight: '5px' }}
                onClick={() => handlers.handleCommentClick({ row, col })}
            />
            {row[col.id]}
        </Typography>
    );
}

CommentField.propTypes = {
    row: object,
    col: object,
    handlers: object,
};

CommentField.defaultProps = {
    row: {},
    col: {},
    handlers: { handleCommentClick: () => {} },
};

export default CommentField;
